export const SIDES = {
  full: 'full',
  left: 'left',
  right: 'right',
};
export const MAX_COMMIT_COUNT = 1000;
